import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=7ac61df8"
import script from "./bindEmail.vue?vue&type=script&lang=js"
export * from "./bindEmail.vue?vue&type=script&lang=js"
import style0 from "./bindEmail.vue?vue&type=style&index=0&id=7ac61df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports